/**
 * useLoadingStates.tsx - Loading Animation States Hook
 *
 * Manages animated loading text and dots for better UX.
 */

import { useEffect, useState } from 'react';
import { t } from 'i18next';

export const useLoadingStates = (loading: boolean) => {
    const [loadingText, setLoadingText] = useState(t("analyzing_your_query"));
    const [loadingTextNumber, setLoadingTextNumber] = useState(1);
    const [loadingDots, setLoadingDots] = useState(".");
    const [loadingDotsNumber, setLoadingDotsNumber] = useState(1);

    useEffect(() => {
        if (loading === true) {
            const timeout = setTimeout(() => {
                setLoadingTextNumber(loadingTextNumber + 1);
            }, 6000);

            if (loadingTextNumber === 1) {
                setLoadingText(t("analyzing_your_query"));
            }

            if (loadingTextNumber === 2) {
                setLoadingText(t("gathering_sources"));
            }

            if (loadingTextNumber === 3) {
                setLoadingText(t("translating_sources"));
            }

            if (loadingTextNumber === 4) {
                setLoadingText(t("preparing_your_answer"));
            }

            if (loadingTextNumber === 5) {
                setLoadingTextNumber(1);
            }

            return () => clearTimeout(timeout);
        }
    }, [loadingTextNumber, loading]);

    useEffect(() => {
        if (loading === true) {
            const timeout = setTimeout(() => {
                setLoadingDotsNumber(loadingDotsNumber + 1);
            }, 1000);

            if (loadingDotsNumber === 1) {
                setLoadingDots(".");
            }

            if (loadingDotsNumber === 2) {
                setLoadingDots("..");
            }

            if (loadingDotsNumber === 3) {
                setLoadingDots("...");
            }

            if (loadingDotsNumber === 4) {
                setLoadingDotsNumber(1);
            }

            return () => clearTimeout(timeout);
        }

        if (loading === false) {
            setLoadingDotsNumber(1);
        }
    }, [loadingDotsNumber, loading]);

    return {
        loadingText,
        loadingDots
    };
};
